export const B2bKey = {
  AVERAGE_TYPE: 'AverageType',
  PRODUCT_ID: 'productId',
  FACILITY_ID: 'facilityId',
  NO_UNIT_TF: 'NoOfUnitSold',
  COST_TF: 'cost',
  ADD_SUPPLIER: 'supplierData',
  SUPPLIER_ID: 'supplierId',
  RAW_MATERIAL: 'rawMaterial',
  FACILITY: 'facility',
  FUEL_EMISSION: 'fuelEmission',
  ELEC_EMISSION: 'electricityEmission',
  WASTE_EMISSION: 'wasteTreatmentEmission',
  VEHICLE_TYPE: 'vehicletype',
  VOLUME_MATERIAL: 'volumeOfMaterail',
  DISTANCE: 'distanceOfMaterailInputToSupplier',
  PRODUCT_TYPE: 'productType',
  WEIGHT_TF: 'weight'
};

export const B2bLabel = {
  AVERAGE_TYPE: 'Product Name',
  PRODUCT_ID: 'Product Name',
  FACILITY_ID: 'Facility Name',
  NO_UNIT_TF: 'No. of units sold',
  COST_TF: 'Cost',
  ADD_SUPPLIER: 'Suppliers',
  SUPPLIER_ID: 'Supplier',
  RAW_MATERIAL: 'Raw Material',
  FACILITY: 'Facility',
  FUEL_EMISSION: 'Fuel Emission',
  ELEC_EMISSION: 'Electricity Emission',
  WASTE_EMISSION: 'Waste Treatment Emission',
  VEHICLE_TYPE: 'Vehicle Type',
  VOLUME_MATERIAL: 'Volume Of Material',
  DISTANCE: 'Distance Of Material Input To Supplier',
  WEIGHT_TF: 'Weight'
};
